import { useMutation } from "@tanstack/react-query";
import { http } from "../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../consts/api";

export const useSetStripeTaxAddress = (options = {}) => {
  const res = useMutation(async (dto) => {
    return http.post(HTTP_ENDPOINTS.stripe.taxAddress(), dto);
  }, options);
  return res;
};
